import { StoreInfoProvider } from "@contexts/StoreInfoContext";

export default function AppProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return <StoreInfoProvider>{children}</StoreInfoProvider>;
}
